module.exports = __webpack_public_path__ + "static/media/mq.1a77ee18.svg";